import { type User } from './user-roles';

export const blankUser: User = {
    name: '',
    email: '',
    ext_user_id: '',
    roles: []
};
